import React from 'react';
import { BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom';
import Gallery from './components/Gallery';
import GalleryItem from './components/GalleryItem';
import FabricItem from './components/FabricItem';
import Archives from './components/Archives';
import Info from './components/Info';
import Fabrics from './components/Fabrics';
import Guestbook from './components/Guestbook';
import './styles/App.scss';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="App__container">
          <Link to="/" className="App__logo">
            <img src={process.env.PUBLIC_URL + '/assets/media/finallogo-background.png'} alt="Logo" className="App__logo-image" />
          </Link>
          
          <div className="App__layout">
            <nav className="left-nav">
              <Link to="/gallery">
                <img src={process.env.PUBLIC_URL + '/assets/icons/Ngallery-background.png'} alt="Gallery" />
              </Link>
              <Link to="/fabrics">
                <img src={process.env.PUBLIC_URL + '/assets/icons/Nfabric-background.png'} alt="Fabric" />
              </Link>
              <Link to="/info">
                <img src={process.env.PUBLIC_URL + '/assets/icons/Ninfo-background.png'} alt="Info" />
              </Link>
            </nav>

            <main className="App__main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/gallery/:itemId" element={<GalleryItem />} />
                <Route path="/archives" element={<Archives />} />
                <Route path="/info" element={<Info />} />
                <Route path="/fabrics" element={<Fabrics />} />
                <Route path="/fabrics/:itemId" element={<FabricItem />} />
                <Route path="/guestbook" element={<Guestbook />} />
              </Routes>
            </main>

            <footer className="App__footer">
              <div className="footer__links">
                <Link to="/">home</Link> | <Link to="/gallery">gallery</Link> | <Link to="/fabrics">fabrics</Link> | <Link to="/info">more information</Link>
              </div>
              <div className="footer__logo">
                <img src={process.env.PUBLIC_URL + '/assets/images/other/n3studio.png'} alt="" />
              </div>
              <p className="footer__copyright">
                &copy; {new Date().getFullYear()} Colorquilts. All rights reserved.
              </p>
            </footer>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
